import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css";

const Sidebar = () => {
  const [openMaster, setOpenMaster] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false); // MOBILE OPEN/CLOSE

  return (
    <>
      {/* MOBILE HAMBURGER */}
      <button
        className="mobile-toggle"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        ☰
      </button>

      <div className={`sidebar-container ${showSidebar ? "open" : ""}`}>
        
        {/* MASTER SECTION */}
        <h3 className="sidebar-heading">MASTER</h3>

        <div className="sidebar-row" onClick={() => setOpenMaster(!openMaster)}>
          <span className="icon">📁</span> Master
          <span>{openMaster ? "▲" : "▼"}</span>
        </div>

        {openMaster && (
          <div className="submenu">
            <NavLink to="/workers" className="submenu-item">
              👤 Workers
            </NavLink>

            <NavLink to="/items" className="submenu-item">
              📦 Items
            </NavLink>

            <NavLink to="/diamonds" className="submenu-item">
              💎 Diamonds
            </NavLink>

            <NavLink to="/master-clear" className="submenu-item">
              🧹 Clear Data
            </NavLink>
          </div>
        )}

        {/* DIAMONDS */}
        <h3 className="sidebar-heading">DIAMONDS</h3>

        <NavLink to="/diamond-transactions" className="sidebar-row sidebar-single">
          <span className="icon">💎</span> Issue / Receive
        </NavLink>

        <NavLink to="/diamond-ledger" className="sidebar-row sidebar-single">
          <span className="icon">📘</span> Ledger
        </NavLink>

        {/* SERVICES */}
        <h3 className="sidebar-heading">SERVICES</h3>

        <NavLink to="/master-filing" className="sidebar-row sidebar-single">
          <span className="icon">🔒</span> Master Filing
        </NavLink>

        <NavLink to="/ledger" className="sidebar-row sidebar-single">
          <span className="icon">📘</span> Ledger
        </NavLink>

        {/* WAX SETTING */}
        <h3 className="sidebar-heading">WAX SETTING</h3>

        <NavLink to="/wax-issue" className="sidebar-row sidebar-single">
          <span className="icon">🧰</span> Issue Wax
        </NavLink>

        <NavLink to="/wax-receive" className="sidebar-row sidebar-single">
          <span className="icon">🔵</span> Receive Wax
        </NavLink>

        <NavLink to="/wax-completed" className="sidebar-row sidebar-single">
          <span className="icon">🟣</span> Completed Lots
        </NavLink>

        <NavLink to="/wax-casting" className="sidebar-row sidebar-single">
          <span className="icon">🟠</span> Casting Done
        </NavLink>
      </div>
    </>
  );
};

export default Sidebar;
